import { Drug } from '../types/drug';

interface AvailableDrugSlice {
    availableDrugs: Drug[];
    selectedDrug: Drug | null;
    matchedSynonymId: string | null;
    setAvailableDrugs: (drugs: Drug[]) => void;
    setSelectedDrug: (
        drug: Drug | null,
        matchedSynonymId?: string | null
    ) => void;
    resetSelectedDrug: () => void;
}

const createAvailableDrugSlice = (set: any) => ({
    availableDrugs: [],
    selectedDrug: null,
    matchedSynonymId: null,
    setAvailableDrugs: (drugs: Drug[]) => set({ availableDrugs: drugs }),
    setSelectedDrug: (
        drug: Drug | null,
        matchedSynonymId: string | null = null
    ) => set({ selectedDrug: drug, matchedSynonymId }),
    resetSelectedDrug: () =>
        set({ selectedDrug: null, matchedSynonymId: null }),
});

export { createAvailableDrugSlice };
export type { AvailableDrugSlice };
